import * as React from 'react'
import { type LucideIcon } from 'lucide-react'
import { cn } from '../lib/utils'

/**
 * MediaStatusChip — статус-чип ПОВЕРХ медиа (обложки, градиенты, картинки).
 * Не интерактивен. Форма как у классического Badge (rounded-full, semibold),
 * но живёт над медиа, поэтому фон — вуаль/семантика с blur:
 * - neutral      — тёмная вуаль + белый (канон «над медиа»): тип доступа и пр. пометки
 * - warning      — на модерации
 * - success      — одобрено
 * - destructive  — отклонено
 * Для статусов НА ПОВЕРХНОСТИ (карточка/панель) используйте <Badge>, не этот чип.
 */
export type MediaStatusChipVariant = 'neutral' | 'warning' | 'success' | 'destructive'

const VARIANT_CLASSES: Record<MediaStatusChipVariant, string> = {
  neutral: 'bg-black/35 text-white',
  warning: 'bg-warning/90 text-warning-foreground',
  success: 'bg-success/90 text-success-foreground',
  destructive: 'bg-destructive/90 text-destructive-foreground',
}

export function MediaStatusChip({
  variant = 'neutral',
  icon: Icon,
  children,
  className,
}: {
  variant?: MediaStatusChipVariant
  icon?: LucideIcon
  children: React.ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full backdrop-blur-sm px-2 py-1 text-[11px] font-semibold',
        VARIANT_CLASSES[variant],
        className,
      )}
    >
      {Icon && <Icon className="w-3 h-3" />}
      {children}
    </span>
  )
}
